export const sty = {
  page: { fontFamily: 'system-ui, sans-serif', color: 'var(--color-text)', backgroundColor: 'var(--color-background)' },

  // Nav
  nav: {
    position: 'sticky', top: 0, zIndex: 100,
    backgroundColor: 'var(--color-background)',
    borderBottom: '1px solid #e5e0d5',
    backdropFilter: 'blur(8px)',
  },
  navInner: {
    maxWidth: '1080px', margin: '0 auto', padding: '0 24px',
    height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  },
  navLogo: {},
  navLinks: { display: 'flex', alignItems: 'center', gap: '6px' },
  navLink: { padding: '7px 14px', fontSize: '14px', fontWeight: '500', color: '#374151', textDecoration: 'none', borderRadius: '6px' },
  navCta: {
    padding: '7px 16px', fontSize: '14px', fontWeight: '700',
    backgroundColor: 'var(--color-primary)', color: '#fff', textDecoration: 'none', borderRadius: '7px',
  },
  hamburgerBtn: {
    display: 'none', flexDirection: 'column', gap: '5px', cursor: 'pointer',
    background: 'none', border: 'none', padding: '6px',
    alignItems: 'center', justifyContent: 'center',
  },
  drawerContent: { padding: '24px 20px', display: 'flex', flexDirection: 'column', gap: '4px' },
  drawerLink: {
    display: 'block', padding: '14px 0', fontSize: '17px', fontWeight: 600,
    color: '#374151', textDecoration: 'none', borderBottom: '1px solid #f0ede8',
  },
  drawerCta: {
    display: 'block', marginTop: '20px', padding: '14px',
    textAlign: 'center', backgroundColor: '#006D77', color: '#fff',
    borderRadius: '10px', fontWeight: 800, fontSize: '15px', textDecoration: 'none',
  },

  // Hero
  hero: {
    backgroundColor: '#006D77',
    backgroundImage: [
      'repeating-linear-gradient(0deg, rgba(255,255,255,0.03) 0px, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 40px)',
      'repeating-linear-gradient(90deg, rgba(255,255,255,0.03) 0px, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 40px)',
    ].join(', '),
    padding: '80px 5%', minHeight: '92vh', boxSizing: 'border-box',
    display: 'flex', alignItems: 'center',
  },
  heroGrid: {
    maxWidth: '1080px', margin: '0 auto', width: '100%',
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', alignItems: 'center',
  },
  heroBadge: {
    display: 'inline-block', backgroundColor: '#83C5BE', color: '#004f58',
    fontWeight: 800, fontSize: '12px', letterSpacing: '2px', textTransform: 'uppercase',
    borderRadius: '20px', padding: '5px 14px', marginBottom: '24px',
  },
  heroH1: {
    fontWeight: 900, fontSize: '54px', color: '#fff',
    lineHeight: '1.1', margin: '0 0 20px', letterSpacing: '-0.5px',
  },
  heroSub: {
    fontSize: '18px', color: 'rgba(255,255,255,0.75)', lineHeight: '1.7',
    margin: '0 0 32px', maxWidth: '440px',
    fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },
  heroCtaRow: { display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' },
  heroPrimary: {
    padding: '14px 28px', backgroundColor: '#FF6B6B', color: '#fff',
    fontWeight: 800, fontSize: '15px', borderRadius: '10px',
    textDecoration: 'none', display: 'inline-block',
  },
  heroSecondary: {
    padding: '14px 28px', backgroundColor: 'transparent', color: '#fff',
    fontWeight: 600, fontSize: '15px', borderRadius: '10px',
    textDecoration: 'none', border: '1.5px solid rgba(255,255,255,0.6)',
    display: 'inline-block',
  },
  heroFinePrint: { fontSize: '13px', color: 'rgba(255,255,255,0.45)', margin: 0 },

  // Hero board (right column)
  heroRight: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
  boardFrame: {
    backgroundColor: '#004f58', borderRadius: '16px', padding: '20px',
    border: '2px solid rgba(255,255,255,0.1)', maxWidth: '400px', width: '100%',
  },
  boardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' },
  boardClass: { fontSize: '12px', color: 'rgba(255,255,255,0.5)', letterSpacing: '1.5px', textTransform: 'uppercase', fontWeight: 600 },
  boardNovel: { fontSize: '11px', color: 'rgba(255,255,255,0.35)' },
  clueBox: { backgroundColor: '#83C5BE', borderRadius: '10px', padding: '12px 16px', marginBottom: '12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  winPattern: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' },
  winPatternLabel: { fontSize: '8px', textTransform: 'uppercase', color: 'rgba(0,79,88,0.65)', letterSpacing: '1px', fontWeight: 600 },
  winPatternGrid: { display: 'grid', gridTemplateColumns: 'repeat(5, 6px)', gap: '2px' },
  winCellOn: { width: '6px', height: '6px', borderRadius: '1px', backgroundColor: '#004f58' },
  winCellOff: { width: '6px', height: '6px', borderRadius: '1px', backgroundColor: 'color-mix(in srgb, #83C5BE 30%, #EDF6F9)' },
  winCellFree: { width: '6px', height: '6px', borderRadius: '1px', backgroundColor: '#FF6B6B' },
  winPatternName: { fontSize: '8px', fontWeight: 800, color: '#004f58', letterSpacing: '1px', textTransform: 'uppercase' },
  clueLabel: {
    fontSize: '10px', textTransform: 'uppercase', color: 'rgba(0,79,88,0.65)',
    letterSpacing: '1.5px', marginBottom: '4px', fontWeight: 600,
  },
  clueWord: { fontFamily: "'Nunito', sans-serif", fontWeight: 900, fontSize: '22px', color: '#004f58' },
  boardGrid: { display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '4px', marginBottom: '10px' },
  boardBingoBtn: {
    width: '100%', backgroundColor: '#FF6B6B', color: '#fff',
    fontFamily: "'Nunito', sans-serif",
    fontWeight: 800, fontSize: '15px', letterSpacing: '1px',
    border: 'none', borderRadius: '8px', padding: '12px',
    opacity: 0.5, cursor: 'default',
  },

  // Sections
  section: { padding: '72px 24px' },
  sectionInner: { maxWidth: '1080px', margin: '0 auto' },
  sectionH2: {
    fontSize: '30px', fontWeight: '800', color: 'var(--color-text)',
    margin: '0 0 10px', textAlign: 'center', letterSpacing: '-0.3px',
  },
  sectionSub: { fontSize: '16px', color: '#6b6b7a', textAlign: 'center', margin: '0 0 40px', lineHeight: '1.6' },

  // Features
  featureSection: { backgroundColor: '#EDF6F9', padding: '100px 5%' },
  featureSectionInner: { maxWidth: '1080px', margin: '0 auto', textAlign: 'center' },
  featureLabel: {
    fontWeight: 800, fontSize: '12px', letterSpacing: '2.5px', textTransform: 'uppercase',
    color: '#FF6B6B', marginBottom: '16px',
  },
  featureH2: {
    fontWeight: 900, fontSize: '38px', color: '#1B1B2F',
    lineHeight: '1.2', margin: '0 0 14px', letterSpacing: '-0.3px',
  },
  featureSub: {
    fontSize: '17px', color: '#4a5568', maxWidth: '520px', margin: '0 auto 52px',
    lineHeight: '1.6', fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },
  featureGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', textAlign: 'left',
  },
  featureCard: {
    backgroundColor: '#fff', borderRadius: '16px', padding: '28px 24px',
    border: '1.5px solid #c2dfe6',
  },
  featureIconWrap: {
    width: '48px', height: '48px', borderRadius: '12px', fontSize: '24px',
    display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px',
  },
  featureH3: { fontSize: '17px', fontWeight: 800, color: '#1B1B2F', margin: '0 0 10px' },
  featureBody: {
    fontSize: '14px', color: '#4a5568', lineHeight: '1.65', margin: 0,
    fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },

  // How it works
  howSection: { backgroundColor: '#006D77', padding: '100px 5%' },
  howInner: { maxWidth: '1080px', margin: '0 auto', textAlign: 'center' },
  howLabel: {
    fontWeight: 800, fontSize: '12px', letterSpacing: '2.5px', textTransform: 'uppercase',
    color: '#83C5BE', marginBottom: '16px',
  },
  howH2: {
    fontWeight: 900, fontSize: '38px', color: '#fff',
    lineHeight: '1.2', margin: '0 0 14px', letterSpacing: '-0.3px',
  },
  howSub: {
    fontSize: '17px', color: 'rgba(255,255,255,0.6)', maxWidth: '520px', margin: '0 auto 52px',
    lineHeight: '1.6', fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },
  howGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px', textAlign: 'left',
  },
  howCard: {
    backgroundColor: 'rgba(255,255,255,0.07)', borderRadius: '16px', padding: '28px 24px',
    border: '1.5px solid rgba(255,255,255,0.1)',
  },
  howStepNum: {
    fontWeight: 900, fontSize: '40px', color: '#83C5BE', opacity: 0.6,
    lineHeight: 1, marginBottom: '12px',
  },
  howCardTitle: { fontSize: '17px', fontWeight: 800, color: '#fff', margin: '0 0 10px' },
  howCardBody: {
    fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: '1.65', margin: 0,
    fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },

  // Library
  libSection: { backgroundColor: '#EDF6F9', padding: '100px 5%' },
  libInner: { maxWidth: '1080px', margin: '0 auto', textAlign: 'center' },
  libLabel: {
    fontWeight: 800, fontSize: '12px', letterSpacing: '2.5px', textTransform: 'uppercase',
    color: '#FF6B6B', marginBottom: '16px',
  },
  libH2: {
    fontWeight: 900, fontSize: '38px', color: '#1B1B2F',
    lineHeight: '1.2', margin: '0 0 14px', letterSpacing: '-0.3px',
  },
  libSub: {
    fontSize: '17px', color: '#4a5568', margin: '0 auto 40px',
    lineHeight: '1.6', fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },
  libGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px',
    textAlign: 'left', marginBottom: '16px',
  },
  libCard: {
    backgroundColor: '#fff', borderRadius: '16px', padding: '20px 18px 20px 22px',
    border: '1.5px solid #c2dfe6', position: 'relative', overflow: 'hidden',
  },
  libAccentBar: {
    position: 'absolute', top: 0, left: 0, width: '4px', height: '100%',
    backgroundColor: '#006D77',
  },
  libGrade: {
    fontSize: '11px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase',
    color: '#006D77', marginBottom: '6px',
  },
  libTitle: { fontWeight: 800, fontSize: '15px', color: '#1B1B2F', lineHeight: '1.3', marginBottom: '4px' },
  libAuthor: { fontSize: '12px', color: '#718096' },
  libWords: {
    fontSize: '12px', color: '#718096', marginTop: '10px', paddingTop: '10px',
    borderTop: '1px solid #d8edf2',
  },
  libNote: {
    backgroundColor: '#daeef4', borderRadius: '10px', padding: '14px 20px',
    border: '1.5px solid #c2dfe6', textAlign: 'center',
    fontSize: '14px', color: '#4a5568',
    fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },

  // Pricing
  pricingSection: { backgroundColor: '#fff', padding: '100px 5%', borderTop: '1.5px solid #c2dfe6' },
  pricingInner: { maxWidth: '1080px', margin: '0 auto', textAlign: 'center' },
  pricingLabel: {
    fontWeight: 800, fontSize: '12px', letterSpacing: '2.5px', textTransform: 'uppercase',
    color: '#FF6B6B', marginBottom: '16px',
  },
  pricingH2: {
    fontWeight: 900, fontSize: '38px', color: '#1B1B2F',
    lineHeight: '1.2', margin: '0 0 14px', letterSpacing: '-0.3px',
  },
  pricingSub: {
    fontSize: '17px', color: '#4a5568', margin: '0 auto 56px',
    lineHeight: '1.6', fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },
  pricingGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)',
    maxWidth: '800px', margin: '0 auto', gap: '24px', textAlign: 'left',
  },
  pricingCardTpt: {
    backgroundColor: '#EDF6F9', borderRadius: '16px', padding: '32px',
    border: '1.5px solid #c2dfe6', display: 'flex', flexDirection: 'column',
  },
  pricingCardSub: {
    backgroundColor: '#fff', borderRadius: '16px', padding: '32px',
    border: '2px solid #006D77', position: 'relative',
    display: 'flex', flexDirection: 'column',
  },
  pricingBestValue: {
    position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)',
    backgroundColor: '#006D77', color: '#fff', fontWeight: 800,
    fontSize: '11px', letterSpacing: '1.5px', textTransform: 'uppercase',
    padding: '5px 16px', borderRadius: '20px', whiteSpace: 'nowrap',
  },
  pricingTier: {
    fontWeight: 700, fontSize: '13px', letterSpacing: '1px', textTransform: 'uppercase',
    color: '#718096', marginBottom: '12px',
  },
  pricingPrice: { fontWeight: 900, fontSize: '40px', color: '#1B1B2F', lineHeight: '1', marginBottom: '10px' },
  pricingPriceSub: { fontSize: '16px', fontWeight: 600, color: '#718096' },
  pricingDesc: {
    fontSize: '13px', color: '#4a5568', lineHeight: '1.6', margin: '10px 0 24px', flex: 1,
    fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },
  pricingList: {
    listStyle: 'none', padding: 0, margin: '0 0 24px',
    display: 'flex', flexDirection: 'column', gap: '10px',
  },
  pricingItem: {
    display: 'flex', gap: '8px', fontSize: '14px', color: '#1B1B2F',
    alignItems: 'flex-start', lineHeight: '1.5',
    fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },
  checkTeal: { color: '#006D77', fontWeight: 800, flexShrink: 0 },
  checkDim:  { color: '#c0ccd4', fontWeight: 800, flexShrink: 0 },
  pricingBtnTpt: {
    display: 'block', textAlign: 'center', padding: '13px',
    border: '2px solid #006D77', borderRadius: '10px',
    color: '#006D77', fontWeight: 800, fontSize: '15px', textDecoration: 'none',
    backgroundColor: 'transparent',
  },
  pricingBtnSub: {
    display: 'block', textAlign: 'center', padding: '13px',
    backgroundColor: '#FF6B6B', borderRadius: '10px',
    color: '#fff', fontWeight: 800, fontSize: '15px', textDecoration: 'none',
  },
  pricingClosing: {
    marginTop: '56px', maxWidth: '640px', marginLeft: 'auto', marginRight: 'auto',
    fontWeight: 900, fontSize: '26px', color: '#1B1B2F',
    letterSpacing: '-0.3px', lineHeight: '1.3',
  },

  // Footer
  footer: {
    backgroundColor: '#EDF6F9', borderTop: '1.5px solid #c2dfe6', padding: '40px 5%',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    flexWrap: 'wrap', gap: '16px',
  },
  footerNav: { display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' },
  footerLink: {
    fontSize: '13px', color: '#718096', textDecoration: 'none',
    fontFamily: "'Nunito Sans', 'Nunito', sans-serif",
  },
  footerCopy: { fontSize: '12px', color: '#a0aec0', fontFamily: "'Nunito Sans', 'Nunito', sans-serif" },
};
